import { render, staticRenderFns } from "./LomMembershipStatusList.vue?vue&type=template&id=237b0ec7"
import script from "./LomMembershipStatusList.vue?vue&type=script&lang=js"
export * from "./LomMembershipStatusList.vue?vue&type=script&lang=js"
import style0 from "./LomMembershipStatusList.vue?vue&type=style&index=0&id=237b0ec7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports